import type { FieldErrors } from '@/shared/api/submit';

type Props = {
  isSaving: boolean;
  saved: boolean;
  errors: FieldErrors;
  onSave: () => void;
};

/** Save button + result feedback (success text, server-wide errors) for detail forms. */
export const SaveBar = ({ isSaving, saved, errors, onSave }: Props) => {
  const common = [...(errors.server ?? []), ...(errors.common ?? [])];
  return (
    <div className="clearfix" style={{ marginTop: 15 }}>
      <button type="button" className="btn btn-info pull-right" disabled={isSaving} onClick={onSave}>
        Сохранить
      </button>
      {saved && <span className="text-green">Данные сохранены успешно</span>}
      {common.map((message) => (
        <p key={message} className="text-red">
          {message}
        </p>
      ))}
    </div>
  );
};
